// نصوص أعلى الصفحة الرئيسية: العنوان المتبدّل (HeroSayings) ولوحة البحث (HeroSearch)
// وسطر حقوق الصورة (HomeHero). انظر src/pages/home/components/.
// النسخة الإنجليزية في en/hero.ts ويجب أن تطابقها في المفاتيح.
// الأرقام تُكتب بالأرقام الغربية كما في بقية الموقع.
const hero = {
  // عنوان الصفحة لقارئ الشاشة (h1). العبارات المتبدّلة مخفية عنه حتى لا تتكرر قراءتها.
  srHeadline: 'ابحث عن عقارك للإيجار أو البيع في صفقات 24',
  // العنوان الظاهر، ثابت لا يتبدّل (2026-10-07): العبارات المتبدّلة احتاجت زر إيقاف.
  // ثلاثة أجزاء: الأوسط بالذهبي (2026-10-08، على غرار rightmove).
  headlineLead: 'اقتنص',
  headlineAccent: 'أحلى صفقة',
  headlineTail: 'عقارية',
  subtitle: 'عقارات للإيجار والبيع في مدن المملكة',

  // العبارات المتبدّلة في العنوان. العبارة الأولى هي home.v2.hero.dealLead مع اسم مدينة
  // متبدّل، ثم هذه بالترتيب. كل عبارة تصف ميزة موجودة فعلاً في الموقع؛ لا ادّعاءات.
  sayings: {
    home: 'ابحث عن منزل يناسب حياتك.',
    describe: 'صِف العقار الذي تريده بكلماتك ونبحث عنه',
    draw: 'ارسم منطقتك على الخريطة واعرض عقاراتها',
    request: 'أضف طلبك ليصل إلى الوسطاء العقاريين',
    deeds: 'أسعار من صفقات مسجّلة لدى وزارة العدل',
    owners: 'للملّاك: اعرض عقارك مجاناً والعمولة عند إتمام الصفقة فقط',
    // زر إيقاف الحركة واستئنافها.
    pause: 'إيقاف تبديل العبارات',
    play: 'استئناف تبديل العبارات',
  },

  // عنوان صغير فوق شريط البحث، يتبع نوع العرض.
  panel: {
    rentLabel: 'ابحث عن عقار للإيجار',
    buyLabel: 'ابحث عن عقار للبيع',
  },
  tabs: {
    label: 'نوع العرض',
    rent: 'للإيجار',
    buy: 'للبيع',
  },
  category: {
    label: 'الفئة',
    residential: 'سكني',
    commercial: 'تجاري',
  },
  bar: {
    label: 'البحث عن عقار',
    city: 'المدينة',
    allCities: 'كل المدن',
    query: 'الحي أو صف ما تريد',
    queryPlaceholder: 'اكتب اسم الحي أو صف العقار الذي تريده',
    type: 'نوع العقار',
    search: 'بحث',
  },
  // اقتراحات حقل «الحي أو صف ما تريد».
  suggestions: {
    label: 'المدن والأحياء المقترحة',
    city: 'مدينة',
    district: 'حي',
  },
  filters: {
    toggle: 'الفلاتر',
    // اسم الزر لقارئ الشاشة حين تكون هناك فلاتر مفعّلة.
    toggleActive: 'الفلاتر (المفعّل منها: {{n}})',
    panel: 'فلاتر البحث',
    clearAll: 'مسح الكل',
    submit: 'بحث',
  },
  map: 'ابحث على الخريطة',

  // سطر حقوق الصورة على الخلفية، ما دامت الصورة تتطلبه (ترخيص CC BY-SA).
  credit: {
    photo: 'الصورة:',
    separator: '، ',
    commons: 'ويكيميديا كومنز',
    edited: '(معدّلة)',
    newTab: '(يفتح في نافذة جديدة)',
  },
};

export default hero;
